__turbopack_context__.v({
  "wrapper": "n0iCEG_wrapper",
});
